import { SearchResultCategoryCode } from '~~/server/api/search/query'
export interface NamdedRoutesLink {
    code: SearchResultCategoryCode
    url_data: { slug: string; title: string }
    url: string
}

const formatUrl = (url: string): string => {
    if(!url.startsWith('/')) {
        url = `/${url}`
    }

    return url
}

export const useNamedRoutesLink = (item: NamdedRoutesLink): VNuxtLinkTo => {
    if (item.code === 'faq-category')
        return {
            name: 'faq-category',
            params: {
                id: item.url,
            },
        }

    if (item.code === 'faqpage')
        return {
            name: 'faq',
        }

    if (item.code === 'faq')
        return {
            name: 'faq-detail',
            params: {
                category: item.url_data?.slug || 'undefined',
                id: item.url,
            },
        }

    if (item.code === 'insurance')
        return {
            name: 'insurance-detail',
            params: {
                category: item.url_data?.slug || 'undefined',
                id: item.url,
            },
        }

    if (item.code === 'insurance_category' && item.url_data)
        return {
            name: 'insurance-category-detail',
            params: {
                id: item.url,
            },
        }

    if (item.code === 'insurance_category' && !item.url_data) {
        return {
            name: 'insurance-categories',
        }
    }

    if (item.code === 'post') {
        return {
            name: 'magazine-detail',
            params: {
                id: item.url,
            },
        }
    }

    if (item.code === 'magazin') {
        return {
            name: 'magazine-detail',
            params: {
                id: item.url,
            },
        }
    }
    if (item.code === 'magazin_category') {
        return {
            name: 'blog-category-detail',
            params: {
                id: item.url,
            },
        }
    }

    if (item.code === 'office') {
        return {
            name: 'office-detail',
            params: {
                id: item.url,
            },
        }
    }

    if (item.code === 'service') {
        return {
            name: 'service-detail',
            params: {
                id: item.url,
            },
        }
    }

    if (item.code === 'fund') {
        return {
            name: 'funds-detail',
            params: {
                id: item.url,
            },
        }
    }
    if (item.code === 'fundspage') {
        return {
            name: 'funds',
        }
    }
    if (item.code === 'impress_post') {
        return {
            name: 'blog-detail',
            params: {
                category: 'pre-novinarov',
                id: item.url,
            },
        }
    }

    if (item.code === 'document') {
        return item.url
    }

    if (item.code === 'form') {
        return {
            name: 'online-services-detail',
            params: {
                id: item.url
            }
        }
    }

    return formatUrl(item.url)
}
